import { render, staticRenderFns } from "./AppShopifyProductTile.vue?vue&type=template&id=c9030a66&"
import script from "./AppShopifyProductTile.vue?vue&type=script&lang=js&"
export * from "./AppShopifyProductTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductTile: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/product-tile/ProductTile.vue').default})
